import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
    padding: 0.5rem 3.5rem;
    background-color: #df352c;
    border: 2px solid #df352c;
    border-radius: 2rem;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 600;
    white-space: nowrap;
`;

export interface EndButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const EndButton: React.FC<EndButtonProps> = ({ children, ...props }) => {
    return (
        <StyledButton {...props} aria-label="End Call">
            End Call
        </StyledButton>
    );
};

export default EndButton;
